import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as styles from './dropdown-with-apply.module.scss';
import { BasicCheckbox, BasicButton, BasicSelect } from '../../assets/common';
import { Spin } from 'antd';

const DROPDOWN_STYLES = {
  padding: '8px 10px',
  maxHeight: 450,
  overflowY: 'auto',
  fontWeight: 400,
  fontSize: 14,
  color: '#181818',
};
const OPTION_STYLES = {
  padding: 6,
};

const DropdownWithApply = ({ options, onApply, dropdownStyles = DROPDOWN_STYLES, optionStyles = OPTION_STYLES, ...args }) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState([]);

  const isAllSelected = selected.length === options?.length;

  const toggleOption = (value) => {
    setSelected((prev) => (prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]));
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelected(options);
    } else {
      setSelected([]);
    }
  };

  const handleApply = () => {
    setOpen(false);
    onApply(selected);
  };

  const dropdownRender = () => (
    <div style={{ ...dropdownStyles }}>
      <Spin spinning={!options || !options.length} size="small">
        <div className={styles.option} style={optionStyles}>
          <BasicCheckbox onChange={handleSelectAll} checked={isAllSelected}>
            (Select All)
          </BasicCheckbox>
        </div>
        {options?.map((option) => (
          <div key={option} style={optionStyles}>
            <BasicCheckbox checked={selected.includes(option)} onChange={() => toggleOption(option)}>
              {option}
            </BasicCheckbox>
          </div>
        ))}
        <div className={styles.btnApply}>
          <BasicButton mode="teal" onClick={handleApply}>
            Apply
          </BasicButton>
        </div>
      </Spin>
    </div>
  );

  return <BasicSelect open={open} onDropdownVisibleChange={setOpen} dropdownRender={dropdownRender} {...args} />;
};

export default DropdownWithApply;

DropdownWithApply.propTypes = {
  options: PropTypes.array,
  onApply: PropTypes.func,
};
